module.exports = __webpack_public_path__ + "static/media/bold.eaa8048c.svg";